import axios from 'axios'

const GroupService = {
  async get (params = {}) {
    return axios.get('admin/groups', { params })
  },

  async post (params = {}) {
    return axios.post('admin/groups', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/groups/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/groups/${data.id}`, { data })
  }
}

export default GroupService
